/**
 * Creates a temporary anchor element to trigger a browser download from a Blob.
 * Handles URL lifecycle (createObjectURL → click → revokeObjectURL).
 */
export function triggerBlobDownload(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
